import { Component, Input, Output, Inject, EventEmitter, DOCUMENT } from '@angular/core';

import { GenericService } from '../../../../../../common/common.service';
import { ConsoleLoggerService } from '../../../../../../common/LoggerService/console-logger.service';

@Component({
    selector: 'app-Comments',
    templateUrl: './TradingLimitcomment.component.html',
    styleUrls: ['./TradingLimitcomment.component.css'],
    standalone: false
})
export class TradingLimitCommentComponent {
  @Input() __oCounterpartyLimit: any;
  @Output() getCommentsUpdated = new EventEmitter<any>();
  @Output() getCommentsCancelled = new EventEmitter<boolean>();
  @Input() __bCommentVisible: boolean = false;
  constructor(@Inject(DOCUMENT) private document: any, public service: GenericService, private Logger: ConsoleLoggerService) {
  }

  btnApply_Click() {
    this.__bCommentVisible = false;
    this.getCommentsUpdated.emit(this.__oCounterpartyLimit);
  }

  btnCancel_Click() {
    this.__bCommentVisible = false;
    this.getCommentsCancelled.emit(false);
  }
}
